import React from 'react';

import { BaseLayout, DefaultNavbar, SmokeBg } from '~common/BaseLayout';

import { ModalProvider } from './hooks/useModalProvider';

export function Layout({
  children,
  navbarVisibility,
}: {
  children: React.ReactNode;
  navbarVisibility?: {
    pools?: boolean;
    levels?: boolean;
    staking?: boolean;
    account?: boolean;
  };
}) {
  return (
    <BaseLayout>
      <SmokeBg>
        <DefaultNavbar {...navbarVisibility} />

        <div className="relative max-w-screen-xll mx-auto py-12 xll:pt-12 xll:pb-16 px-2">
          <ModalProvider>{children}</ModalProvider>
        </div>
      </SmokeBg>
    </BaseLayout>
  );
}
